import { Component } from "@angular/core";
import { AuthService } from "@app/auth/services/auth.service";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "@app/shared/services/user.service";
import { StoreService } from "@app/shared/services/store.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent {
  error: string | undefined;
  passwordError: string | undefined;
  emailError: string | undefined;
  email: string;
  password: string;
  loading: boolean = false;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private userService: UserService,
    private storeService: StoreService,
    ) {}

  onSubmit(loginForm: NgForm) {
    if (loginForm.invalid) {
      this.emailError = loginForm.controls.email.invalid ? "Please enter your email address." : undefined;
      this.passwordError = loginForm.controls.password.invalid ? "Please enter your password." : undefined;
      return;
    }
    this.loading = true;

    this.userService.clearUser();
    this.storeService.clearStore();

    this.authService
      .login(this.email, this.password)
      .subscribe((response) => {
        if (response.ok) {
          setTimeout(() => {
            const redirectTo = this.route.snapshot.queryParams.redirectTo;
            window.location.href = redirectTo || "/";
          }, 1000);
        } else if (response.status === 403) {
          this.error = "Client blocked by server.";
        } else if (response.status === 429) {
          this.loading = false;
          this.passwordError = "Too many attempts. Try again later.";
        } else if (response.status === 401) {
          this.loading = false;
          this.passwordError = "That's not the right email or password.";
        } else {
          this.loading = false;
          this.passwordError = "An unknown error has occurred.";
        }
      }, () => {
        this.loading = false;
        this.passwordError = "That's not the right email or password..";
      });
  }
}
